import { Component, EventEmitter, Input, Output } from '@angular/core'
import { b } from '@angular/core/src/render3'
import { runToPageSelected } from 'src/app/_helpers/InteractionsWithTables'

@Component({
	selector: 'app-select-length-table',
	templateUrl: './select-length-table.component.html'
})
export class SelectLengthTable {

	@Output() public valueChangeEmit = new EventEmitter<string>()
	@Output() public runToPage = new EventEmitter<number>()
	@Input() public value: string = '10'
	@Input() public itensSelected: number = 0
	@Input() public pagesSelected: Array<number> = []

	public changeValue() {
		this.valueChangeEmit.emit(this.value)
	}

	@Input() public set pagesSelectedInput(pagesSelected: Array<number>) {
		this.pagesSelected = pagesSelected.sort((a, b) => a - b)
	}

	public selectPage(pageSelected: number) {
		this.pagesSelected.sort()
		runToPageSelected(pageSelected - 1)
	}
}
